// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  width: 100%;
  box-sizing: border-box;
  padding: 16px 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 0 0 auto;
  margin-right: auto;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  flex: 0 0 auto;
}

.user-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
  padding-right: 4px;
  border-right: 1px solid rgba(255, 255, 255, 0.25);
  margin-right: 4px;
}

.user-name {
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1.2;
  white-space: nowrap;
}

.user-email {
  font-size: 0.75rem;
  opacity: 0.85;
  line-height: 1.2;
  white-space: nowrap;
}

.logout-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 14px;
  background: rgba(255, 255, 255, 0.15);
  border: 1.5px solid rgba(255, 255, 255, 0.8);
  color: white;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}

.logout-button:hover {
  background: white;
  color: #667eea;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.token-remain {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  border: 1.5px solid rgba(255, 255, 255, 0.45);
  color: #fff;
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.header-google-chat-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: none;
  transition: transform 0.15s ease, background 0.15s ease;
}

.header-google-chat-btn:hover {
  background: rgba(255, 255, 255, 0.14);
  transform: translateY(-1px);
}

.header-google-chat-btn:active {
  transform: translateY(0);
}

.global-search-container {
  margin-left: 12px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
  height: 34px;
}

.global-search-input {
  width: 220px;
  height: 100%;
  font-size: 13px;
  font-weight: 800;
  border: none;
  background: transparent;
  color: white;
  padding: 0 12px;
  outline: none;
}

.global-search-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.global-search-button {
  height: 100%;
  padding: 0 12px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.global-search-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: row;
    gap: 6px;
    padding: 16px 12px;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }

  .header-left {
    flex: 0 0 auto;
  }

  .user-info {
    width: auto;
    justify-content: flex-end;
    gap: 6px;
    flex-wrap: nowrap;
  }

  .user-details {
    gap: 1px;
    align-items: flex-end;
    padding-right: 6px;
    margin-right: 2px;
  }

  .user-name {
    font-size: 0.82rem;
  }

  .user-email {
    font-size: 0.7rem;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,4CAA4C;EAC5C,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".app-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.header-content {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 16px 16px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 8px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  flex: 0 0 auto;\n  margin-right: auto;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  flex: 0 0 auto;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1px;\n  padding-right: 4px;\n  border-right: 1px solid rgba(255, 255, 255, 0.25);\n  margin-right: 4px;\n}\n\n.user-name {\n  font-weight: 700;\n  font-size: 0.9rem;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.user-email {\n  font-size: 0.75rem;\n  opacity: 0.85;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.logout-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  padding: 0 14px;\n  background: rgba(255, 255, 255, 0.15);\n  border: 1.5px solid rgba(255, 255, 255, 0.8);\n  color: white;\n  border-radius: 999px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 600;\n  white-space: nowrap;\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.logout-button:hover {\n  background: white;\n  color: #667eea;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n}\n\n.token-remain {\n  display: inline-flex;\n  align-items: center;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1.5px solid rgba(255, 255, 255, 0.45);\n  color: #fff;\n  font-weight: 800;\n  font-size: 13px;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.header-google-chat-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: none;\n  transition: transform 0.15s ease, background 0.15s ease;\n}\n\n.header-google-chat-btn:hover {\n  background: rgba(255, 255, 255, 0.14);\n  transform: translateY(-1px);\n}\n\n.header-google-chat-btn:active {\n  transform: translateY(0);\n}\n\n.global-search-container {\n  margin-left: 12px;\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  overflow: hidden;\n  height: 34px;\n}\n\n.global-search-input {\n  width: 220px;\n  height: 100%;\n  font-size: 13px;\n  font-weight: 800;\n  border: none;\n  background: transparent;\n  color: white;\n  padding: 0 12px;\n  outline: none;\n}\n\n.global-search-input::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.global-search-button {\n  height: 100%;\n  padding: 0 12px;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: none;\n  border-left: 1px solid rgba(255, 255, 255, 0.3);\n  cursor: pointer;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.global-search-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n@media (max-width: 768px) {\n  .header-content {\n    flex-direction: row;\n    gap: 6px;\n    padding: 16px 12px;\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n  }\n\n  .header-left {\n    flex: 0 0 auto;\n  }\n\n  .user-info {\n    width: auto;\n    justify-content: flex-end;\n    gap: 6px;\n    flex-wrap: nowrap;\n  }\n\n  .user-details {\n    gap: 1px;\n    align-items: flex-end;\n    padding-right: 6px;\n    margin-right: 2px;\n  }\n\n  .user-name {\n    font-size: 0.82rem;\n  }\n\n  .user-email {\n    font-size: 0.7rem;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
